import { RedirectMechanismType } from '@graphql/generated-base';

/**
 * The one `telemetryDestinationName` the backend sends on a direct-booking replacement.
 *
 * Pinning to it is deliberate. A direct-booking redirect skips the safe-link interstitial, which
 * exists to warn guests about links a couple pasted in — not about our own vetted brand URL. That
 * skip is the risky half of the behaviour, so it is scoped to the single destination we know the
 * backend builds, rather than to any `custom` mechanism that happens to arrive with the flag set.
 */
const DIRECT_BOOKING_DESTINATION_NAME = 'directBooking';

type DirectBookingRedirectLike = Readonly<{
  type?: Maybe<RedirectMechanismType>;
  url?: Maybe<string | URL>;
  telemetryDestinationName?: Maybe<string>;
}>;

/**
 * Whether this redirect is the brand's own direct-booking link standing in for the OTA redirect.
 *
 * Shared by the guest accommodations page (`buildDirectBookingRedirectUrl`) and hotel search
 * (`useAccommodationRedirectUrl`) so the two surfaces cannot drift on what counts as one.
 */
export const isDirectBookingRedirect = (isDirectBooking: boolean | undefined, redirectData: DirectBookingRedirectLike | undefined): boolean =>
  isDirectBooking === true &&
  redirectData?.type === RedirectMechanismType.custom &&
  redirectData.telemetryDestinationName === DIRECT_BOOKING_DESTINATION_NAME &&
  !!redirectData.url;
